import { Group, Paper, Stack, Text, Title } from '@mantine/core'

import { UserManagement } from '../UserManagementScreen/UserManagement'

interface SmeManagementPanelProps {
  showTutorialText: boolean
}

export function SmeManagementPanel({ showTutorialText = false }: SmeManagementPanelProps) {
  return (
    <Stack>
      <Paper radius="md" p="lg" shadow="sm" px="xl">
        <Group justify="space-between" mb="md">
          <Title order={4}>Invite Experts</Title>
        </Group>

        {showTutorialText && (
          <Text size="md" c="dimmed" mb="md">
            Invite experts from your organization to build the content modules used by Expert Sidekicks to support end
            users. Program managers can also build content modules for Expert Sidekicks.
          </Text>
        )}

        <UserManagement role="SME" showRoleColumn={false} entityName="Expert" />
      </Paper>
    </Stack>
  )
}
